import { Injectable, Injector } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "../../../auth.service";
const holidayScheduleText = 'Holiday Schedules';
const holidayScheduleValue = 'Holiday-Schedule';
const defaultNotifyContactText = 'Default Notification Contacts';
const defaultNotifyContactValue = 'Default-Notification-Contacts';
const bannerMessage = 'Banner Message';
@Injectable()
export class AdministrationService {
  router: Router;
  userModule: any;
  
  BodyDropdownList = [

    {
      text: 'Tracking Vehicle Numbers',
      value: 'Tracking-Vehicle-Number'
    },
    {
      text: 'Total Vehicle Numbers',
      value: 'Total-Vehicle-Number'
    },
    {
      text: 'Request Types',
      value: 'Request-Type'
    },
    {
      text: 'Program Details',
      value: 'Body-Program-Details'
    },
    {
      text: 'mBOMs',
      value: 'mBOM'
    },
    {
      text: holidayScheduleText,
      value: holidayScheduleValue
    },
    {
      text: 'Gates',
      value: 'Gate'
    },
    {
      text: 'Deliverables',
      value: 'Deliverables'
    },
    {
      text: defaultNotifyContactText,
      value: defaultNotifyContactValue
    },
    {
      text: bannerMessage,
      value: 'Banner'
    },
    {
      text: 'Areas',
      value: 'Areas'
    },
  ];

  GADropdownList = [
    {
      text: 'Additional Information Categories',
      value: 'Additional-Information-Category'
    },
    {
      text: 'Architectures',
      value: 'Architecture'
    },
    {
      text: bannerMessage,
      value: 'Banner'
    },
    {
      text: 'CME Areas',
      value: 'CME-Area'
    },
    {
      text: defaultNotifyContactText,
      value: defaultNotifyContactValue
    },
    {
      text: 'Gates',
      value: 'Gate'
    },
    {
      text: holidayScheduleText,
      value: holidayScheduleValue
    },
    {
      text: 'Program Details',
      value: 'Ga-Program-Details'
    },
    {
      text: 'SMTs',
      value: 'SMT'
    },
    {
      text: 'Study Titles',
      value: 'Study-Titles'
    },
    {
      text: 'Tooling Operator Interfaces',
      value: 'Tooling-Operator-Interfaces'
    },
  ];

  CommonDropdownList = [
    {
      text: bannerMessage,
      value: 'Banner'
    },
    {
      text: defaultNotifyContactText,
      value: defaultNotifyContactValue
    },
    {
      text: 'Gates',
      value: 'Gate'
    },

    {
      text: holidayScheduleText,
      value: holidayScheduleValue
    }
  ];

  constructor(
    private readonly injector: Injector,
    private readonly authService: AuthenticationService
    ) {
    this.router = this.injector.get(Router);
    this.authService = this.injector.get(AuthenticationService);
    this.userModule = this.authService.getModule();
  }

  getCurrentPageValue() {
    const splits = this.router.url.split('/');
    return splits[splits.length - 1];
  }

  dropdownSelectionChange = (selected: any) => {
    this.router.navigate([`VE/Administration/${selected.value}`]);
  }

  getDropdownList(): any[] {
    let list: any[];

    switch (this.userModule) {
      case 'VE_GA':
        list = this.GADropdownList;
        break;
      case 'VE_Body':
        list = this.BodyDropdownList;
        break;
      default:
        list = this.CommonDropdownList;
        break;
    }

    return list;
  }
}
